import angular from 'angular';

/**
 * @ngdoc overview
 * @name commonModule.loading
 * @description
 * # commonModule.loading
 * Collection of 'loading' text directive.
 */
const loading = angular.module('commonModule.loading', []);

/**
 * @ngdoc directive
 * @name commonModule.loading.directive:loadingText
 * @description
 * Directive for showing "Loading" text
 */
loading.directive('loadingText', function () {
    'use strict';
    return {
        restrict: 'AE',
        templateUrl: 'views/common/components/loading/loadingText.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.loading.directive:loadingText
 * @description
 * Directive for showing "Loading" text
 */
loading.directive('loadingDataText', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            position: '@',
            size: '@'
        },
        templateUrl: 'views/common/components/loading/loadingDataText.tpl.html',
        link: function (scope) {
            if (!scope.position) {
                scope.position = 'center';
            }

            if (!scope.size) {
                scope.size = 50;
            }
        }
    };
});

/**
 * @ngdoc directive
 * @name commonModule.loading.directive:loadingText
 * @description
 * Directive for showing spinner
 */
loading.directive('loadingSpinner', function () {
    'use strict';
    return {
        restrict: 'AE',
        templateUrl: 'views/common/components/loading/loadingSpinner.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.loading.directive:loadingChart
 * @description
 * Directive for showing "Loading" text for charts
 */
loading.directive('loadingChart', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: {
            type: '@',
            size: '@'
        },
        templateUrl: 'views/common/components/loading/loadingChart.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.loading.directive:loadingTable
 * @description
 * Directive for showing "Loading" text in the table
 */
loading.directive('loadingTable', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: {
            colSpan: '='
        },
        templateUrl: 'views/common/components/loading/loadingTable.tpl.html'
    };
});

export default loading;